// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8319b527","453":"09637201","667":"7ae76b55","977":"3459bc2c"}[chunkId] + ".chunk.js";
};